import { Validator } from 'vee-validate';
const numericRegExp = /^[-]?[0-9]+$/;

/**
 * Numeric2 validator supports also negative values.
 */
const numeric2 = function (value) {
  if (Array.isArray(value)) {
    return value.every(val => numericRegExp.test(String(val)));
  }

  return numericRegExp.test(String(value));
};

Validator.extend('numeric2', numeric2);



// WEBPACK FOOTER //
// ./client/validation/numericValidator.js